"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderColumn = exports.DragDataType = exports.HeaderColumnStyleName = void 0;
var tslib_1 = require("tslib");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var CSSMacros_1 = require("./CSSMacros");
var DataGridColors_1 = require("./DataGridColors");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var ResizeHandleStyle = {
    bottom: 0,
    cursor: 'col-resize',
    position: 'absolute',
    right: "calc(" + DataGridColors_1.DataGridLines.HeaderDividerWidth + " / -2)",
    translate: '50%',
    top: 0,
    width: "calc(max(12px, " + DataGridColors_1.DataGridLines.HeaderDividerWidth + "))",
    zIndex: 1,
};
exports.HeaderColumnStyleName = typestyle_1.style({
    backgroundColor: DataGridColors_1.DataGridColors.HeaderBackground,
    borderBottom: DataGridColors_1.DataGridLines.HeaderBorderWidth + " " + DataGridColors_1.DataGridLines.HeaderBorderStyle + " " + DataGridColors_1.DataGridLines.HeaderBorderColor,
    boxSizing: 'border-box',
    display: 'inline-block',
    height: '100%',
    position: 'relative',
    // TODO maybe no longer needed with flexbox parent
    verticalAlign: 'top',
    $nest: (_a = {},
        _a["[role=\"grid\"]." + DataGridColors_1.VerticalLines + " &"] = {
            borderRight: DataGridColors_1.DataGridLines.HeaderDividerWidth + " " + DataGridColors_1.DataGridLines.HeaderDividerStyle + " " + DataGridColors_1.DataGridLines.HeaderDividerColor,
        },
        _a['&:has(> [role="columnheader"][aria-selected="true"])'] = {
            backgroundColor: DataGridColors_1.DataGridColors.Selected,
            borderBottomColor: DataGridColors_1.DataGridColors.SelectedLine,
            borderRightColor: DataGridColors_1.DataGridColors.SelectedLine,
        },
        _a['&:has(+ & > [role="columnheader"][aria-selected="true"])'] = {
            // add a border on the left side of a selection range (via right border on the previous column)
            borderRightColor: DataGridColors_1.DataGridColors.SelectedLine,
        },
        _a)
});
var HeaderStyle = tslib_1.__assign({ height: '100%', overflow: 'hidden' }, CSSMacros_1.PreventUserSelect);
var GlobalCursorStyleName = typestyle_1.style({ $unique: true, cursor: ResizeHandleStyle.cursor });
exports.DragDataType = 'Text';
var HeaderColumn = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderColumn, _super);
    function HeaderColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        _this.state = { hovered: false };
        _this.handleStartResize = function (event) {
            document.body.classList.add(GlobalCursorStyleName);
            var resizeMouseX = widgets_1.getClientPosition(event).x;
            var rect = _this.domRef.current.getBoundingClientRect();
            var initialWidth = rect.right - rect.left;
            var handleMouseMove = function (e) {
                var delta = e.clientX - resizeMouseX;
                _this.props.onColumnResize(_this.props.col, initialWidth + delta);
                e.preventDefault();
            };
            var handleMouseUp = function (e) {
                var _a, _b;
                document.body.classList.remove(GlobalCursorStyleName);
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                e.preventDefault();
                (_b = (_a = _this.props).onColumnResizeFinish) === null || _b === void 0 ? void 0 : _b.call(_a);
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            event.preventDefault();
        };
        _this.columnDivider = (React.createElement("div", { "aria-hidden": true, className: 'tb-react-dg-hdivider tb-disable-selection', "data-resizehandle": true, onMouseDown: _this.handleStartResize, style: ResizeHandleStyle }));
        _this.handleClick = function (e) {
            if (e.target !== e.currentTarget && Utils_1.isFocusable(e.target)) {
                // presume that we don't want to trigger a cell handler if an interactive child was clicked
                return;
            }
            var handler = {
                click: _this.props.onHeaderClick, contextmenu: _this.props.onHeaderContextMenu, dblclick: _this.props.onHeaderDoubleClick,
                doubleclick: _this.props.onHeaderDoubleClick, // this is wrong but either Enzyme or React monkeypatches it in during testing, even when invoked with 'dblclick'
            }[e.type];
            handler === null || handler === void 0 ? void 0 : handler(null, { colIdx: _this.props.colIdx, colKey: _this.props.col.dataKey, rowIdx: -1 }, e);
        };
        _this.handleMouseEnter = function () { return _this.setState({ hovered: true }); };
        _this.handleMouseLeave = function () { return _this.setState({ hovered: false }); };
        _this.handleDragStart = function (e) {
            if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey) {
                e.preventDefault();
                return;
            }
            e.dataTransfer.setData(exports.DragDataType, _this.props.col.name);
            e.dataTransfer.effectAllowed = 'move';
        };
        return _this;
    }
    HeaderColumn.prototype.componentDidMount = function () {
        var _a, _b;
        (_b = (_a = this.props).reportWidthFn) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.col.name, Utils_1.measureWidth(this.domRef.current));
    };
    HeaderColumn.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, col = _d.col, colIdx = _d.colIdx, minWidth = _d.minWidth, width = _d.width;
        var isSortable = col.sortable !== false;
        var isResizable = col.resizable !== false;
        var formatterProps = tslib_1.__assign(tslib_1.__assign({}, this.props), this.state);
        /* eslint-disable deprecation/deprecation */
        var children = this.props.col.headerComponent ? React.createElement(this.props.col.headerComponent, tslib_1.__assign({}, formatterProps)) :
            (_c = (_b = (_a = this.props.col).headerFormatter) === null || _b === void 0 ? void 0 : _b.call(_a, formatterProps)) !== null && _c !== void 0 ? _c : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: col.headerText, testId: col.name + '-HeaderFormatter' });
        /* eslint-enable */
        return (React.createElement("div", { className: typestyle_1.classes('tb-react-dg-hcol', exports.HeaderColumnStyleName), "data-colindex": colIdx, ref: this.domRef, style: { minWidth: minWidth, width: width } },
            React.createElement("div", { "aria-colindex": this.props.colIdx + 1, "aria-rowindex": 1, "aria-selected": this.props.isSelected, "aria-sort": this.props.sorted ? (this.props.sortAscending ? 'ascending' : 'descending') : 'none', className: typestyle_1.classes('tb-react-dg-hcell', { 'tb-react-dg-hcell-sortable': isSortable, 'tb-react-dg-hcell-resizable': isResizable }), "data-tb-test-id": this.props.sorted ? (this.props.sortAscending ? 'data-grid-hcell-ascending' : 'data-grid-hcell-descending') : undefined, draggable: this.props.draggable, onClick: this.handleClick, onContextMenu: this.handleClick, onDoubleClick: this.handleClick, onDragStart: this.handleDragStart, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, role: 'columnheader', style: HeaderStyle, tabIndex: this.props.tabIndex, title: col.headerTooltip }, children),
            isResizable && this.columnDivider));
    };
    HeaderColumn.displayName = 'DataGridHeaderColumn';
    return HeaderColumn;
}(React.PureComponent));
exports.HeaderColumn = HeaderColumn;
//# sourceMappingURL=HeaderColumn.js.map